import { CompositionPosition } from "features/CenterContent/VehicleDetails/TrainDetails/TrainComposition/types";

const flipOrientation = {
  A: "B",
  B: "A",
};

const baseUrl = "https://trainicons.vy.no/";

export const getVehicleImage = (
  vehicleType: CompositionPosition["vehicleType"],
  orientation: string,
) => {
  if (!vehicleType) {
    return `${baseUrl}unknown-${
      flipOrientation[orientation.toUpperCase() as keyof typeof flipOrientation]
    }.gif`;
  }

  return `${baseUrl}${vehicleType.replace(" ", "%20")}-${
    flipOrientation[orientation.toUpperCase() as keyof typeof flipOrientation]
  }.gif`;
};
